export default "__VITE_ASSET__BAF68J2v__"